var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { customEvent, EventError, EventType } from '@assets/utils/customEvent';
import useLocalStorage from '@embed/hooks/useLocalStorage';
import { useApi } from './useApi';
const getChannelFromStorage = (fromStorage) => {
    if (!fromStorage || !fromStorage.expire || !fromStorage.channel) {
        return null;
    }
    const now = new Date();
    const TOO_OLD = 12 * 60 * 60 * 1000;
    if (now.getTime() > fromStorage.expire + TOO_OLD) {
        return null;
    }
    return fromStorage.channel;
};
export const useChannelStorage = ({ username, encodedId, target, }) => {
    const api = useApi();
    const [channelStorage, setChannelStorage] = useLocalStorage(`_fwnchnnl_${username || encodedId}`, null);
    const [channel, setChannel] = useState(getChannelFromStorage(channelStorage));
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const now = new Date();
            const isExpired = (channelStorage === null || channelStorage === void 0 ? void 0 : channelStorage.expire) && now.getTime() > (channelStorage === null || channelStorage === void 0 ? void 0 : channelStorage.expire);
            if ((!channel || isExpired) && (username || encodedId)) {
                try {
                    const result = username
                        ? yield api.getChannel(username)
                        : yield api.getChannelById(encodedId !== null && encodedId !== void 0 ? encodedId : '');
                    setChannel(result.channel);
                    const ttl = 10 * 60 * 1000; //10min
                    setChannelStorage({
                        expire: new Date().getTime() + ttl,
                        channel: result.channel,
                    });
                }
                catch (e) {
                    customEvent({
                        target,
                        type: [EventType.FW_ERROR, EventType.FW_EMBEDFEED_ERROR],
                        data: {
                            detail: EventError.API_ERROR,
                        },
                    });
                }
            }
        }))();
    }, [
        api,
        username,
        encodedId,
        channel,
        channelStorage === null || channelStorage === void 0 ? void 0 : channelStorage.expire,
        setChannelStorage,
        setChannel,
        target,
    ]);
    return channel;
};
